import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatRippleModule } from '@angular/material/core';

import { FrostOverlayMenuComponent } from './frost-overlay-menu.component';

@NgModule({
    declarations: [
        FrostOverlayMenuComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FontAwesomeModule,
        MatRippleModule
    ],
    exports: [
        FrostOverlayMenuComponent
    ]
})
export class FrostOverlayMenuModule { } 